// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1mqQT","content":"styles_content__5Sc8m","selectAll":"styles_selectAll__FZEJE"};